
















export default {
  props: {
    exmpleItem: {
      type: Object,
      default: {}
    },
    rightPhotoColor: {
      type: String,
      default: ''
    },
    wrongPhotoColor: {
      type: String,
      default: '#F06A5B'
    }
  }
};
